var _jsxFileName = "/codebuild/output/src1493404089/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/InputErrorField/index.tsx";
import React, { memo } from 'react';
import { HStack, Text } from '@adc/parallax-component-library';
import { IconValidationInvalid } from '@adc/parallax-icons';
// TODO: remember to delete when fully moved to parallax inputs
const InputErrorField = /*#__PURE__*/memo(({
  testID,
  errorMessage
}) => {
  if (!errorMessage) {
    return null;
  }
  return /*#__PURE__*/React.createElement(HStack, {
    marginBottom: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(IconValidationInvalid, {
    color: "$support.danger.surfaceOnColorAlt",
    testID: `${testID}-icon`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Text, {
    display: "flex",
    testID: `${testID}-errorMessage`,
    nativeID: `${testID}-errorMessage`,
    color: "$support.danger.surfaceOnColorAlt",
    fontSize: "$bodySmall.default",
    marginLeft: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  }, errorMessage));
});
InputErrorField.displayName = 'InputErrorField';
export { InputErrorField };